<script setup lang="ts">
import {
  useSchemaOrg,
  defineWebPage,
  defineWebSite,
  defineOrganization,
} from '@unhead/schema-org/vue'

const color = computed(() => '#111827')
const config = useRuntimeConfig()
const { shouldShowCookieBanner } = useGdpr()

// Cookie banner control
const showBanner = ref(false)

// Initialize cookie banner based on GDPR status and PostHog opt-in/out status
onMounted(() => {
  if (import.meta.client) {
    // Update banner visibility based on our GDPR utility
    showBanner.value = shouldShowCookieBanner.value
  }
})

useHead({
  title: 'AERO.NOW • The 5-min Daily Aerospace Newsletter',
  meta: [
    { charset: 'utf-8' },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover',
    },
    { key: 'theme-color', name: 'theme-color', content: color },
  ],
  link: [{ rel: 'icon', href: '/favicon.ico' }],
  htmlAttrs: {
    lang: 'en',
    class: 'dark',
  },
})

useSeoMeta({
  description:
    'AERO.NOW is your essential 5-minute morning briefing on aerospace trends, technology breakthroughs, market insights, and strategic analysis!',
  ogImage: `${config.public.siteUrl}/social-card.png`,
  twitterImage: `${config.public.siteUrl}/social-card.png`,
  ogTitle: 'AERO.NOW • The 5-min Daily Aerospace Newsletter',
  ogDescription:
    'AERO.NOW is your essential 5-minute morning briefing on aerospace trends, technology breakthroughs, market insights, and strategic analysis!',
  ogType: 'website',
  ogSiteName: 'AERO.NOW',
  ogUrl: config.public.siteUrl,
  twitterCard: 'summary_large_image',
  twitterTitle: 'AERO.NOW • The 5-min Daily Aerospace Newsletter',
  twitterDescription:
    'AERO.NOW is your essential 5-minute morning briefing on aerospace trends, technology breakthroughs, market insights, and strategic analysis!',
})

// Add JSON-LD structured data
useSchemaOrg([
  defineWebPage({
    name: 'AERO.NOW',
    description:
      'AERO.NOW is your essential 5-minute morning briefing on aerospace trends, technology breakthroughs, market insights, and strategic analysis!',
  }),
  defineWebSite({
    name: 'AERO.NOW',
    url: config.public.siteUrl,
  }),
  defineOrganization({
    name: 'AERO.NOW',
    logo: `${config.public.siteUrl}/logo.png`,
    url: config.public.siteUrl,
    sameAs: [
      'https://twitter.com/aeronewsletter',
      'https://instagram.com/aeronewsletter',
      // 'https://linkedin.com/company/aeronow',
    ],
  }),
])
</script>

<template>
  <div>
    <NuxtLoadingIndicator color="red" />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <UNotifications />
    <ClientOnly>
      <CookieBanner v-if="showBanner" @hide-banner="showBanner = false" />
    </ClientOnly>
  </div>
</template>
